import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { forkJoin, map, Observable } from 'rxjs';
import { FileUploadService } from 'src/app/services/shared/file-upload.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { SharedService } from 'src/app/services/shared-service.service';
import { EndCustomerService } from 'src/app/services/end-customer.service';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { AuthService } from 'src/app/services/auth.service';
import Swal from 'sweetalert2';
import { SpinnerService } from 'src/app/services/shared/spinner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbService } from 'src/app/services/shared/breadcrumb.service';

@Component({
  selector: 'app-add-support-tickets',
  templateUrl: './add-support-tickets.component.html',
  styleUrls: ['./add-support-tickets.component.scss']
})

export class AddSupportTicketsComponent implements OnInit {

  ticketForm!: FormGroup;
  commentsForm!: FormGroup;
  image: File | null = null;
  selectedFile: boolean = false;
  showImage:string | undefined;
  fileName = '';
  currentFile?: File;
  selectedFileName: string | null = null;
  imageURL: string[] = [];
  issueRelated: string[] = [];
  roleName!: string;
  createdBy!: string;
  ticketStatusDropDown: string[] = ['Open','Under Review','In Progress','Closed','Re open','Cancel'];
  ticketStatusObj: any={
    'Open': 'Open',
    'Under Review': 'UnderReview',
    'In Progress': 'InProgress',
    'Closed': 'Closed',
    'Re open': 'ReOpen',
    'Cancel': 'Cancel'
  }
  userId!: string;
  addComment: boolean = false;
  commentsFormList: any[] = [];
  isEditComment: string = '';
  attendeeGroups: string[] = [];
  attachedFiles: string[] = [];
  attachedFileUrls: string[] = [];
  fileArray: File[] = [];
  showWarning : boolean = false;
  allFiles: File[] = [];
  uploadedFileUrl: string | null = null;
  uploadedFileName: string | null = null;
  isEditable: boolean = false;
  isSuperAdmin: boolean = false;
  ticket: any={};
  isStaff: boolean = false;
  userDetailsById: any;
  userDetails: any;
  @Input() updateTicketId: any = false;
  @Input() viewcomment : boolean = false;
  @Input() updateticket : boolean = false;
  @Output() back = new EventEmitter<any>();
  dropDowns: any = {
    issueRelated: [],
    priorityLevel: [],
    assignTo: [],
    raisedFor: [],
  }
  raisedForData: any;
  adminCreated: boolean = false;
  block: boolean = false;

  @Output() updateEvent = new EventEmitter<any>();

  @ViewChild('uploadAttachments') uploadAttachments!: ElementRef;

  constructor(
    private fb: FormBuilder,
    private fileUploadService: FileUploadService,
    private localStorageService: LocalStorageService,
    private sharedService: SharedService,
    private endCustomerService: EndCustomerService,
    private cdRef: ChangeDetectorRef,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private spinnerService: SpinnerService,
    private breadcrumbService: BreadcrumbService
  )
  {
    this.userDetails = JSON.parse(localStorageService.getItem('userDetails') as string);
    this.userId = localStorageService.getItem('userId');
    this.roleName  = localStorageService.getItem('roleName');
    if(this.roleName === 'OEM'){
      this.createdBy = localStorageService.getItem('oemId');
    }
    else if(this.roleName === 'DISTRIBUTOR') {
      this.createdBy = localStorageService.getItem('distributorId');
    }
    else if (this.roleName === 'USER') {
      this.roleName = 'CUSTOMER'
      this.createdBy = localStorageService.getItem('userId');
    }else if(this.roleName === 'SUPER_ADMIN') {
      this.roleName = 'SUPER_ADMIN'
      this.createdBy = localStorageService.getItem('userId');
      if (localStorageService.getItem('accountName') === 'Staff') {
        this.isStaff = true;
      }
    }
    else if (this.roleName === 'SUPER_ADMIN' && localStorageService.getItem('accountName') === 'Staff') {
      this.isStaff = true;
      
    }else {
       this.isSuperAdmin = true;
    }
    if(this.updateTicketId && (this.isStaff || !this.ticket.adminCreated)) {
      this.block = true;
    }
  }

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '10rem',
    minHeight: '0rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    showToolbar: false,
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],

    toolbarHiddenButtons: [
      [
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        'subscript',
        'superscript',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        'heading',
        'fontName',
        'undo',  // Hide undo
        'redo',  // Hide redo
        'insertUnorderedList',  // Hide bullet points (unordered list)
        'insertOrderedList',    // Hide numbered points (ordered list)
        'insertLine',           // Hide line
      ],
      [
        'fontSize',
        'textColor',
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  };

  configComment: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '10rem',
    minHeight: '0rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    showToolbar: false,
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
    toolbarHiddenButtons: [
      [
        'bold',
        'italic',
        'underline',
        'strikeThrough',
        'subscript',
        'superscript',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        'heading',
        'fontName',
        'undo',  // Hide undo
        'redo',  // Hide redo
        'insertUnorderedList',  // Hide bullet points (unordered list)
        'insertOrderedList',    // Hide numbered points (ordered list)
        'insertLine',           // Hide line
      ],
      [
        'fontSize',
        'textColor',
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  };

  ngOnInit(): void {
    this.setbreadcrumb();
    this.route.queryParams.subscribe(params => {
      this.isEditable = params['isEditable'] === 'true';
      if (this.isEditable && this.updateTicketId) {        
        this.updateTicketForm();
      }
    });
    this.getDropDowns();
    this.initializeTicketForm();
    if(this.updateTicketId) {
      this.initializeCommentForm();
      this.updateTicketForm();
    }
    if(this.block? true: false) {
      this.config.editable = false;
    }
  }

  convertion(value: string) {
    switch (value) {
      case 'OEM':
        return 'OEM';
      case 'DISTRIBUTOR':
        return 'Distributor';
      case 'CUSTOMER':
        return 'Customer';
      case 'OTHER':
        return 'Other';
      default:
        return '';
    }
  }

  onUserTypeChange(event: any) {
    this.sharedService.userDetailsSupportTicket(event, 0, 100).subscribe((data: any) => {
      if (event === '' || event.toLowerCase() === 'other') {
        this.dropDowns.raisedFor = [{ name: 'Other' }];
        this.raisedForData = { name: 'Other' };
        this.ticketForm.patchValue({
          raisedFor: { name: 'Other' },
        });
      }
        this.dropDowns.raisedFor = data.data;
        if(!this.dropDowns.raisedFor) {
          this.dropDowns.raisedFor = [{ name: 'Other' }];
        }
        this.dropDowns.raisedFor.forEach((item: any) => {
          if(!item.userId) {
            this.raisedForData = item;
            this.ticketForm.patchValue({
              raisedFor: item,
            });
          }
          else if (item.userId === this.ticket.userId) {
            this.raisedForData = item;
            this.ticketForm.patchValue({
              raisedFor: item,
            });
          }
        });
    });
  }

  onRaisedForChange(event: any) {
    this.raisedForData = this.getUserDetailsById(event.userId, 'SUPER_ADMIN');
  }

  getUserDetailsById1(id: string, type: string) {
    this.authService.getDetailsByUserId(id).subscribe((res: any) => {
      if (res) {
        this.userDetailsById = res.data;
      }
    });
  }

  getUserDetailsById(id: string, type: string) {
    if(id){
      this.authService.getDetailsByUserId(id).subscribe((res: any) => {
        if (res) {
        this.spinnerService.showSpinner();
        this.ticketForm.patchValue({
            name: res.data?.userName || this.ticket.name,
            phoneNumber: res.data?.phoneNumber || this.ticket.phoneNumber,
            email: res.data?.email || this.ticket.email,
          })
          this.spinnerService.hideSpinner();
          return res.data;
        }
      });
    }
  }

  initializeTicketForm(){
    this.ticketForm = this.fb.group({
      userType: new FormControl('',[Validators.required]),
      raisedFor: new FormControl('',[Validators.required]),
      name: new FormControl((this.roleName !== 'SUPER_ADMIN')? this.userDetails.userName: '', [Validators.required]),
      phoneNumber: new FormControl((this.roleName !== 'SUPER_ADMIN')? this.userDetails.phoneNumber: '', []),
      email: new FormControl( (this.roleName !== 'SUPER_ADMIN')? this.userDetails.email: '', [Validators.required, Validators.email]),
      issueRelated: new FormControl('', [Validators.required]),
      subject: new FormControl('', [Validators.required]),
      description: new FormControl('', []),
      attachments: new FormControl([],[]),
      ticketStatus: new FormControl('', [Validators.required]),
      priorityLevel: new FormControl('', []),
      assignedTo: new FormControl('', [Validators.required]),
      comments: new FormControl([],[]),
      createdBy: new FormControl(this.userId, []),
      role: new FormControl(this.roleName, []),
    });
  }

  getDropDowns() {
    return forkJoin({
      issueRelated: this.sharedService.issueRelated(),
      priorityLevel: this.sharedService.priortyLevel(),
      assignTo: this.sharedService.assignTo()
    }).subscribe({
      next: (res: any) => {
        res.issueRelated.data.forEach((element: any) => {
          this.dropDowns.issueRelated.push(element.name);
        });
        res.priorityLevel.data.forEach((element: any) => {
          if (!this.dropDowns.priorityLevel.includes(element.levelName)) {
            this.dropDowns.priorityLevel.push(element.levelName);
          }
        });
        this.dropDowns.assignTo = res.assignTo.data;
      },
      error: (err : any) => {
      }
    });
  }

  initializeCommentForm() {
    this.commentsForm = this.fb.group({
      createdBy: new FormControl(this.userId),
      commentMessage: new FormControl([], []),
      createdOn: new FormControl('', []),
      commentAttachments: new FormControl([], []),
      supportTicketId: new FormControl(this.updateTicketId, [])
    })
  }

  getTicketById() {
    this.sharedService.ticketById(this.updateTicketId).subscribe((res: any)=>{
      this.ticket = res.data;
      if(this.ticket.raisedBy !== this.userId) {        
        this.block = true;
      }
      this.onUserTypeChange(this.ticket.role);
      const ticketKey = Object.keys(this.ticketStatusObj).find((key: any)=> {
        return this.ticket.ticketStatus.toLowerCase() === this.ticketStatusObj[key].toLowerCase();
      });
      this.ticket.ticketStatus = ticketKey;
      let convertedTicketStatus ;
      const tm = this.getUserDetailsById1(this.ticket.raisedBy, '');    
      this.ticketStatusDropDown.map((status: any) => {
        if (status.toLowerCase() === this.ticket.ticketStatus.toLowerCase()) {
          convertedTicketStatus=status;
      }})
      const raisedForTmp = (this.getUserDetailsById(this.ticket.userId, ''));
      if(this.ticket.role === 'OTHER') {
        this.dropDowns.raisedFor = [{name: 'Other'}];
      }
      
      if(this.roleName === 'DISTRIBUTOR' || this.roleName === 'OEM' || this.localStorageService.getItem('roleName') === 'USER') {
        this.ticketForm.patchValue({
          userType: (this.ticket.role === 'OTHER')? 'Other': this.convertion(this.ticket.role),
          raisedFor: (this.ticket.role === 'OTHER')? (this.dropDowns.raisedFor[0].name): ('temporary'),
          name: this.ticket.name,
          phoneNumber: this.ticket.phoneNumber,
          email: this.ticket.email,
          issueRelated: this.ticket.issueRelated,
          subject: this.ticket.subject,
          description: this.ticket.description,
          attachments: this.ticket.attachments,
          ticketStatus: convertedTicketStatus,
          priorityLevel: this.ticket.priorityLevel,
          assignedTo: this.ticket.assignedTo,
          role: this.localStorageService.getItem('roleName') === 'DISTRIBUTOR'? 'DISTRIBUTOR' : this.localStorageService.getItem('roleName') === 'OEM'? 'OEM': 'CUSTOMER',
          createdBy: this.ticket.createdBy
        }) 
      } else {
        this.ticketForm.patchValue({
          userType: (this.ticket.role === 'OTHER')? 'Other': this.convertion(this.ticket.role),
          raisedFor: (this.ticket.role === 'OTHER')? (this.dropDowns.raisedFor[0].name): ('temporary'),
          name: this.ticket.name,
          phoneNumber: this.ticket.phoneNumber,
          email: this.ticket.email,
          issueRelated: this.ticket.issueRelated,
          subject: this.ticket.subject,
          description: this.ticket.description,
          attachments: this.ticket.attachments,
          ticketStatus: convertedTicketStatus,
          priorityLevel: this.ticket.priorityLevel,
          assignedTo: this.ticket.assignedTo,
          role: (this.roleName !== 'SUPER_ADMIN')? this.ticket.name : 'OTHER' ,
          createdBy: this.ticket.createdBy
        }) 
      } 
      this.getDropDowns();
      this.imageURL=[...this.ticket.attachments.map((url: any) => this.getFileName(url))];
      if(this.imageURL && this.imageURL.length > 0){
        this.selectedFile = true;     
      } else {
        this.selectedFile = false;
      }
    })
    this.cdRef.detectChanges();

    this.getComments();
    this.spinnerService.hideSpinner();
  }

  getFileName(url: string): string {
    const parts = url.split('/');
    const fileName = parts[parts.length - 1];
    if (fileName && fileName[0] && fileName[0].match(/\d/)) {
      return fileName.substring(1);
    }
    return fileName;
  }

  commentAttchement: any[] = [];

  getComments() {
    this.spinnerService.showSpinner();
    this.sharedService.getCommentsByTicketId(this.updateTicketId).subscribe((res: any) => {
      this.commentsFormList = res?.data ?? [];
      this.commentAttchement = this.commentsFormList.map((comment: any) => comment.commentAttachments);
      this.spinnerService.hideSpinner();
    });
  }

  editComment(comment: any) {
    this.attachedFiles = comment.commentAttachments.map((url: any) => this.getFileName(url));
    this.attachedFileUrls = comment?.commentAttachments;
    this.commentsForm.patchValue({
      createdBy: this.userId,
      commentMessage: comment.commentMessage,
      commentAttachments: this.attachedFiles,
      createdOn: comment.createdOn,
      supportTicketId: comment.supportTicketId
    })
    this.addComment = true;
    this.isEditComment = comment.id;    
  }

  deleteComment(comment: any) {
    Swal.fire({
      position: 'center',
      title: 'Are you sure?',
      text: 'You will not be able to recover the deleted record!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete It',
      cancelButtonText: 'Cancel'   
    }).then((result) => {
      if (result.value) {
        this.sharedService.deleteComment(comment.id).subscribe((res: any)=>{
          Swal.fire(
            'Removed!',
            'Item Removed Successfully.',
            'success'
          );
          this.getComments();
          },
          (error) => {
            Swal.fire(
              'Error',
              'There was an error deleting the item.',
              'error'
            );
           
          }
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Cancelled',
          'Item is safe.',
          'error'
        );
      }
    });



  }

  updateTicketForm() {
    this.getTicketById();
  }

  removeAttachedFile(i: any) {
    if(this.block) {
      return;
    }
    let atchUrls = this.ticketForm?.get('attachments')?.value;
    atchUrls = atchUrls.filter((data: any, id:number)=>i!==id);
    this.ticketForm?.get('attachments')?.setValue([...atchUrls]);
    this.imageURL = this.imageURL.filter((data: any, id:number)=>i!==id)
    if (this.imageURL.length == 0 && this.ticketForm?.get('attachments')?.value.length == 0) {
      this.selectedFile = false;
    }
  }

  removeUploadedFile(i: number): void {
    this.attachedFiles = this.attachedFiles.filter((data: any, id:number)=>i!==id)
    this.attachedFileUrls = this.attachedFileUrls.filter((data: any, id:number)=>i!==id);
    this.uploadedFileUrl = null;
    this.uploadedFileName = null;
  }

  uploadPhoto(event: any, isDragAndDrop: boolean): void {
    this.spinnerService.showSpinner();
    event.preventDefault();
    const input = event.target as HTMLInputElement;
    const file: FileList = (isDragAndDrop)? event.dataTransfer.files: event.target.files;
    if (file) { 
      this.fileArray = Array.from(file);
      this.allFiles = this.fileArray
      this.fileArray.forEach((file: File) => {
        this.uploadedFileName = file.name;
        this.attachedFiles.push(file.name) ;
        const uploadData = new FormData();
        uploadData.append('file', file);
        const randomNumber = Math.floor(Math.random() * 10) + 1;
        uploadData.append('destinationKey', randomNumber.toString());

      this.endCustomerService.executePostRequestForAuth(MweConstants.uploadFile, uploadData)
        .subscribe(data => {
          if (data && data?.data) {
            this.uploadedFileUrl = data.data;
            this.attachedFileUrls.push(data.data)
            this.commentsForm?.get('commentAttachments')?.setValue([...this.attachedFileUrls]);
            input.value = '';
          }
          this.spinnerService.hideSpinner();
        }, error => {
          
        });
      })
    }
  }

  addCommentToList() {
    if(this.isEditComment){
      const req ={
        id: this.isEditComment,
        commentAttachments: [...this.attachedFileUrls], 
        supportTicketId: this.updateTicketId,
        commentMessage: this.commentsForm.value.commentMessage,
        createdOn: this.commentsForm.value.createdOn,
        createdBy: this.commentsForm.value.createdBy
      } 
      
      this.sharedService.editComment(this.isEditComment, req).subscribe((res: any)=>{
        Swal.fire(
          'Updated!',
          'Item Updated Successfully.',
          'success'
        )
        this.getComments();
        this.isEditComment = '';
      })
    }
    else{
      this.commentsForm.patchValue({
        createdBy: this.userId,
        commentAttachments: [...this.attachedFileUrls],
        supportTicketId: this.updateTicketId,
      })
      this.sharedService.addComments(this.commentsForm.value).subscribe((res: any)=>{
        Swal.fire(
          'Updated!',
          'Item Added Successfully.',
          'success'
        )
        this.getComments();
      })
    }
    this.commentsForm.reset();
    this.addComment = false;
    this.viewcomment = true;
    this.attachedFiles = [];
    this.attachedFileUrls = [];
  }

  addComments() {
    this.viewcomment=false;
    this.commentsForm.reset();
    this.attachedFiles=[];
    this.attachedFileUrls = [];
    this.addComment = true;
  }

  cancelComment() {
    this.commentsForm.reset();
    this.attachedFiles = [];
    this.addComment = false;
    this.viewcomment = true;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  private getFileNameFromUrl(url: string): string {
    return url.split('/').pop() || '';
  }

  private uploadFile(file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('destinationKey', '/subscriptions/');
    return this.fileUploadService.uploadFile(formData).pipe(
      map((response: any) => {
        if (response && response.data) {
          // this.imageURL.push(response.data);
          this.selectedFile = true;
          return response.data; // Extracting file name from URL
        } else {
          throw new Error('Invalid response format from server.');
        }
      })
    );
  }

  selectFile(event: any, isDragAndDrop: boolean): void {
    if(this.block) {
      return;
    }
    event.preventDefault();
    const input = (isDragAndDrop)? event.dataTransfer : event.target as HTMLInputElement; 
    const files: FileList = (isDragAndDrop)? event.dataTransfer.files : event.target.files;
    const filesArray: File[] = Array.from(files);
    filesArray.forEach((file: File) =>{
      this.uploadFile(file).subscribe((url: string) => {
        this.ticketForm?.get('attachments')?.setValue([...this.ticketForm?.get('attachments')?.value, url]);
        this.imageURL.push(file.name);
        input.value = '';
      });
    })
  }

  editTicket() {
    this.viewcomment=true;
    this.isEditable = true;
    this.updateticket = true;
    this.router.navigate([], {
    queryParams: { isEditable: true},
    queryParamsHandling: 'merge', 
    state:{
      editedTicketPage: true,
      ticketId: this.updateTicketId
    }
  });
  this.breadcrumbService.setBreadcrumbs(['Dashboard','Edit Support Ticket']);
  }

  cancel(){
    this.viewcomment = false;
    this.ticketForm.reset();
    // this.back.emit([true, this.updateticket]);
    this.updateEvent.emit(this.updateticket);
    this.routeTo(this.isEditable);
    this.breadcrumbService.setBreadcrumbs(['Dashboard',this.isEditable ? 'View Support Ticket' : 'Support Tickets']);
  }

  routeTo(section: boolean) {
    if(section){ 
      if(this.roleName==='DISTRIBUTOR'){
        this.router.navigate(['/dashboard/distributor/support'], { queryParams: { ticketId: this.updateTicketId } });
      }else if(this.roleName==='OEM'){
        this.router.navigate(['/dashboard/oem/support'], { queryParams: { ticketId: this.updateTicketId } });
      }else{
        this.router.navigate(['/dashboard/super-admin/support-tickets'], { queryParams: { ticketId: this.updateTicketId }});
      }
    }
    else{
      if(this.roleName==='DISTRIBUTOR'){
        this.router.navigate(['/dashboard/distributor/support']);
      }else if(this.roleName==='OEM'){
        this.router.navigate(['/dashboard/oem/support']);
      }else{  
        this.router.navigate(['/dashboard/super-admin/support-tickets']);
      }
    }
    this.spinnerService.hideSpinner();
  }

  fillAllFields() {
    Swal.fire({
      position: 'center',
      title: 'Please fill all the fields',
      icon: 'warning',
      confirmButtonText: 'Ok',
    })
  }

  saveForm(){

    if (this.roleName === 'SUPER_ADMIN') {
      if (this.ticketForm.invalid) {
        this.fillAllFields();
        return;
      }
    } else if (this.roleName === 'DISTRIBUTOR' || this.roleName === 'OEM' || this.localStorageService.getItem('roleName')==='USER') {
      if (
        !this.ticketForm.get('name')?.valid ||
        !this.ticketForm.get('email')?.valid ||
        !this.ticketForm.get('issueRelated')?.valid ||
        !this.ticketForm.get('subject')?.valid
      ) {
        this.fillAllFields();
        return;
      }
    }
    else {
      if (
        !this.ticketForm.get('userType')?.valid ||
        !this.ticketForm.get('raisedFor')?.valid ||
        !this.ticketForm.get('name')?.valid ||
        !this.ticketForm.get('email')?.valid ||
        !this.ticketForm.get('issueRelated')?.valid ||
        !this.ticketForm.get('subject')?.valid ||
        !this.ticketForm.get('ticketStatus')?.valid ||
        !this.ticketForm.get('assignedTo')?.valid 
      ) {
        this.fillAllFields();
        return;
      }
    }
    let globalObj;
    if(this.roleName === 'DISTRIBUTOR' || this.localStorageService.getItem('roleName') === 'USER' || this.roleName === 'OEM') {

      globalObj = {
        name: this.ticketForm.get('name')?.value,
        phoneNumber: this.ticketForm.get('phoneNumber')?.value,
        email: this.ticketForm.get('email')?.value,
        issueRelated: this.ticketForm.get('issueRelated')?.value,
        subject: this.ticketForm.get('subject')?.value,
        description: this.ticketForm.get('description')?.value,
        attachments: this.ticketForm.get('attachments')?.value,
        createdBy: this.ticketForm.get('createdBy')?.value,
        role: (this.ticketForm.get('userType')?.value)? (this.ticketForm.get('userType')?.value.toUpperCase()): this.ticketForm.get('role')?.value.toUpperCase(),
        adminCreated: (this.roleName === 'SUPER_ADMIN')
      } 
    } else{
      const keyStatus = this.ticketForm?.get('ticketStatus')?.value;
    this.ticketForm?.get('ticketStatus')?.setValue(this.ticketStatusObj?.[keyStatus]);
    globalObj= {
      userId: this.ticketForm.get('raisedFor')?.value.userId || '' ,
      name: this.ticketForm.get('name')?.value,
      phoneNumber: this.ticketForm.get('phoneNumber')?.value,
      email: this.ticketForm.get('email')?.value,
      issueRelated: this.ticketForm.get('issueRelated')?.value,
      subject: this.ticketForm.get('subject')?.value,
      description: this.ticketForm.get('description')?.value,
      attachments: this.ticketForm.get('attachments')?.value,
      ticketStatus: this.ticketForm.get('ticketStatus')?.value.toUpperCase(),
      priorityLevel: this.ticketForm.get('priorityLevel')?.value,
      assignedTo: this.ticketForm.get('assignedTo')?.value,
      comments: this.ticketForm.get('comments')?.value,
      createdBy: this.ticketForm.get('createdBy')?.value,
      role: (this.ticketForm.get('userType')?.value)? (this.ticketForm.get('userType')?.value.toUpperCase()): this.ticketForm.get('role')?.value.toUpperCase(),
      adminCreated: (this.roleName === 'SUPER_ADMIN')

    } 
    }  
    if(this.updateTicketId) {
      this.ticketForm.value.comments = (this.commentsFormList);
        this.sharedService.updateTicket(this.updateTicketId, globalObj).subscribe((res: any)=>{
          Swal.fire(
            'Updated!',
            'Item Updated Successfully.',
            'success'
          )
          this.ticketForm.reset();
          this.cancel();
        },
        (error) => {
          Swal.fire(
            'Error',
            'There was an error Updating the item.',
            'error'
          );
        })
    }
    else{
      this.sharedService.saveTicket(globalObj).subscribe((res: any)=>{
        Swal.fire(
          'Updated!',
          'Item Added Successfully.',
          'success'
        )
        this.ticketForm.reset();
        this.cancel();
      },
      (error) => {
        Swal.fire(
          'Error',
          'There was an error Updating the item.',
          'error'
        );
      });
    }
  }

 
  firstColumnFields = [
    { label: 'Name', value: this.ticket?.name || 'N/A' },
    { label: 'Phone Number', value: this.ticket?.phoneNumber || 'N/A' },
    { label: 'Registered Email ID', value: this.ticket?.email || 'N/A' },
    { label: 'Issue Related', value: this.ticket?.issueRelated || 'N/A' },
    { label: 'Subject', value: this.ticket?.subject || 'N/A' },
    { label: 'Description', value: this.ticket?.description || 'N/A' }
  ];

  secondColumnFields = [
    { label: 'Attachments', value: this.ticket?.attachments?.length ? this.ticket?.attachments.join(', ') : 'N/A' },
    { label: 'Submitted By', value: this.ticket?.submittedBy || 'N/A' },
    { label: 'Created By', value: this.ticket?.createdBy || 'N/A' },
    { label: 'Created On', value: this.ticket?.createdOn ? new Date(this.ticket?.createdOn).toLocaleDateString() : 'N/A', isDate: true },
    { label: 'Updated By', value: this.ticket?.updatedBy || 'N/A' },
    { label: 'Updated On', value: this.ticket?.updatedOn ? new Date(this.ticket?.updatedOn).toLocaleDateString() : 'N/A', isDate: true }
  ];
  

  getAssignedToName(assignedToId: number | string): string {
    // Ensure dropDowns.assignTo is an array
    if (Array.isArray(this.dropDowns.assignTo) && assignedToId) {
      const assign = this.dropDowns.assignTo.find((item: any) => item.id === assignedToId);
      return assign ? assign.name : 'Not Assigned';
    }
    return 'Not Assigned'; // Fallback if no match is found or assignTo is not an array
  }

  uploadSupportTicket(event: any, isDragAndDrop: boolean): void {
    event.preventDefault();
    const input = event.target as HTMLInputElement;
    const file: FileList = (isDragAndDrop)? event.dataTransfer.files: event.target.files;
    if (file) { 
      this.fileArray = Array.from(file);
      this.allFiles = this.fileArray
      this.fileArray.forEach((file: File) => {
        this.uploadedFileName = file.name;
        this.attachedFiles.push(file.name) ;
        const uploadData = new FormData();
        uploadData.append('file', file);
        const randomNumber = Math.floor(Math.random() * 10) + 1;
        uploadData.append('destinationKey', randomNumber.toString());

      this.endCustomerService.executePostRequestForAuth(MweConstants.uploadFile, uploadData)
        .subscribe(data => {
          if (data && data?.data) {
            this.uploadedFileUrl = data.data;
            this.attachedFileUrls.push(data.data)
            this.ticketForm?.get('attachments')?.setValue([...this.attachedFileUrls]);
            input.value = '';
          }
        }, error => {
          
        });
      })
    }
  }
  
  triggerAttachmentsInputClick(){
    if(this.isStaff || this.isSuperAdmin){
      return;
    }
    this.uploadAttachments.nativeElement.click();
  }
  
  setbreadcrumb() {
    if (this.router.url.includes('isEditable')) {
      this.breadcrumbService.setBreadcrumbs(['Dashboard','Edit Support Ticket']);
    }
    else if (this.router.url.includes('ticketId')) {
      this.breadcrumbService.setBreadcrumbs(['Dashboard', 'View Support Ticket']);
    }
    else if (this.router.url.includes('raise-a-ticket')) {
      this.breadcrumbService.setBreadcrumbs(['Dashboard', 'Add Support Ticket']);
    } 
    else if (this.router.url.includes('support-tickets') && !this.router.url.includes('isEditable') && !this.router.url.includes('ticketId') && !this.router.url.includes('raise-a-ticket')) {
    this.breadcrumbService.setBreadcrumbs(['Dashboard', 'Support Tickets']);
    }
  }
}